<template>
  <div class="aside-primary d-flex flex-column align-items-lg-center flex-row-auto">
    <div
      class="aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto py-10"
      id="kt_aside_logo"
    >
      <a href="#">
        <img
          alt="Logo"
          src="/media/svg/files/svg_logo.svg"
          class="h-40px"
        />
      </a>
    </div>

    <div
      class="aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0"
      id="kt_aside_nav"
    >
      <!-- // ! AsidePrimary Header -->
      <div
        class="hover-scroll-y mb-10"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-height="auto"
        data-kt-scroll-wrappers="#kt_aside_nav"
        data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
        data-kt-scroll-offset="0px"
      >
        <ul class="nav flex-column">
          <li
            class="nav-item mb-2"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-placement="right"
            data-bs-dismiss="click"
            title=""
            data-bs-original-title="Menu"
          ></li>
        </ul>
      </div>
      <!-- // ! AsidePrimary Header -->
    </div>

    <!-- // ! AsidePrimary Footer -->
    <div
      class="aside-footer d-flex flex-column align-items-center flex-column-auto"
      id="kt_aside_footer"
    >
      <div
        class="d-flex align-items-center mb-10"
        id="kt_header_user_menu_toggle"
      >
        <div
          class="cursor-pointer symbol symbol-40px"
          data-kt-menu-trigger="click"
          data-kt-menu-overflow="true"
          data-kt-menu-placement="top-start"
          data-kt-menu-flip="top-end"
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          data-bs-dismiss="click"
          title="User profile"
        >
          <img
            :src="user.AvatarUrl === null ? 'media/avatars/blank.png' : user.AvatarUrl"
            alt="Photo"
          />
        </div>
        <KTUserMenu></KTUserMenu>
      </div>
    </div>
    <!-- // ! AsidePrimary Footer -->
  </div>
</template>

<script lang="en">
import { defineComponent } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "kt-aside-primary",
  components: {
    KTUserMenu,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters["AuthModule/_getUser"]);

    return {
      user,
    };
  },
});
</script>
